var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-0 pa-0",staticStyle:{"height":"20px"},attrs:{"small":"","flat":"","color":"primary","disabled":_vm.loading,"loading":_vm.loading},on:{"click":function($event){return _vm.goToTask()}}},[(_vm.checkTask)?_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("done")]):_vm._e(),_vm._v(" "+_vm._s('#' + _vm.taskID)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }